import {createContext} from 'react';

export type StepContentContextValue = {
	active: boolean;
	disabled: boolean;
	index: number;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const StepContentContext = createContext<StepContentContextValue>(null);
